export default {
    assign_firmware_title: "Assign Firmware",
    assign_firmware_the_device_is_already_added: "The device is already added",
    assign_firmware_of_device_is_higher: "The current firmware of the device is higher",
    assign_firmware_hardware_version_not_valid: "Hardware version of the device is not valid",
    assign_firmware_the_device_manu_must_be_vidfleet: "The device manufacturer must be Vidfleet",
    assign_firmware_no_device_found: "No device found",
    assign_firmware_the_firmware_was_assigned: "The firmware was assigned",
    assign_firmware_unable_to_update_fimware: "Unable to update firmware",
    assign_firmware_Id: "Id",
    assign_firmware_hardware_version: "Hardware Version",
    assign_firmware_firmware_version: "Firmware Version",
    assign_firmware_firmware_type: "Firmware Type",
    assign_firmware_status: "Status",
    assign_firmware_default: "Default",
    assign_firmware_file: "File",
    assign_firmware_description: "Description",
    assign_firmware_apply_scopes: "Apply Scopes",
    assign_firmware_partial_message: "Only the cameras listed below will take the firmware",
    assign_firmware_default_message: 'This firmware will be applied as "DEFAULT" for "ALL" new devices added to PLATFORM',
    assign_firmware_all_message: 'This FIRMWARE will be applied for "ALL" existing devices on the PLATFORM',
    assign_firmware_all_error: "Cannot be assigned to all devices because the firmware is not default",
    assign_firmware_current_firmware: "Current Firmware",
    assign_firmware_apply: "Apply",
    assign_firmware_serial: "Serial",
    assign_firmware_imei: "IMEI",
    assign_firmware_imei_or_serial: "IMEI or Serial",
    assign_firmware_firmware_details: "Firmware details",
}

